import BaseModel from './BaseModel';
import CronTaskInterval from './CronTaskInterval';
import moment from 'moment';
import _ from 'lodash';
import { v4 } from 'uuid';

/** Class representing a cron task. */
class CronTask extends BaseModel {
    static STATUS_PENDING     = 'pending';
    static STATUS_IN_PROGRESS = 'in_progress';

    static METHOD_GET    = 'GET';
    static METHOD_POST   = 'POST';
    static METHOD_PUT    = 'PUT';
    static METHOD_PATCH  = 'PATCH';
    static METHOD_DELETE = 'DELETE';
    static METHOD_HEAD   = 'HEAD';

    static methods() {
        return [
            CronTask.METHOD_GET,
            CronTask.METHOD_POST,
            CronTask.METHOD_PUT,
            CronTask.METHOD_PATCH,
            CronTask.METHOD_DELETE,
            CronTask.METHOD_HEAD
        ];
    }

    constructor(properties) {
        super(properties);

        this.history = (this.history || []).map(interval => new CronTaskInterval(interval));

        if (this.created_at)
            this.created_at = moment(this.created_at);
        if (this.updated_at)
            this.updated_at = moment(this.updated_at);
    }

    nbExecutions() {
        return (this.history || []).reduce((acc, interval) => acc + interval.nb, 0)
    }

    /**
     * Prepare this object for duplicate.
     * This is used to "normalize", if needed, some properties
     * before to send them.
     *
     * return{BaseModel}
     */
    prepareForDuplicate() {
        const prepared = _.cloneDeep(this);

        prepared._id   = v4();
        prepared.name += ' copy';

        delete prepared.created_at;
        delete prepared.updated_at;
        delete prepared.status;

        return prepared;
    }
}

export default CronTask;
